import { render, staticRenderFns } from "./syssetting-record.vue?vue&type=template&id=19e95ad3&scoped=true"
import script from "./syssetting-record.vue?vue&type=script&lang=js"
export * from "./syssetting-record.vue?vue&type=script&lang=js"
import style0 from "./syssetting-record.vue?vue&type=style&index=0&id=19e95ad3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e95ad3",
  null
  
)

export default component.exports